import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import useWorkshopQuery from 'hooks/useWorkshopQuery';

async function update(axios: AxiosInstance, id: number, lock_reason: string): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/workshop/${id}/lock`, {
    reason: `${lock_reason}`,
  });
  return data;
}

export default function useLockWorkshopMutation(workshopId: number) {
  const queryClient = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: (params: { id: number; lock_reason: string }) => update(axios, params.id, params.lock_reason),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: useWorkshopQuery.getKey(workshopId) });
    },
  });
}
